class ColetoresHistoricosModal {
    constructor(scope, gql) {
        this.apply = (fn) => scope.$apply(fn)
        this.gql = gql
    }

    $onInit() {
        this.listHistoricos()
    }

    listHistoricos() {
        const query = gql`
            query ListColetorHistoricos {
                contrato: empresa(id: ${this.resolve.contratoId}) {
                    id
                    historicos: coletoresHistoricos(filter: {acao: ENVIO_ARQUIVO, limit: 25}) {
                        id
                        acao
                        insertedAt
                        coletor {
                            id
                            nome
                            versao
                            usuario {
                                id
                                nome
                            }
                        }
                        config {
                            id
                            diretorio
                        }
                    }
                }
            }
        `

        return this.gql.query(query)
            .then(({ contrato }) => contrato)
            .then(contrato => {
                this.apply(() => this.historicos = contrato.historicos)
            })
    }
}

angular.module('eficienciaFiscalModule')
    .component('coletoresHistoricosModal', {
        controller: ['$scope', 'gql', ColetoresHistoricosModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Histórico de envio dos coletores" close="$ctrl.close">
                <modal-body>
                    <highlighted>
                        <main>Últimos envios dos seus coletores.</main>
                        <secondary>Aqui serão listados os últimos 25 envios realizados pelos coletores cadastrados para essa empresa.</secondary>
                    </highlighted>
                    <table class="table table-hover table-striped" style="border: 1px #ddd solid; border-radius: 3px; margin-bottom: 0">
                        <thead>
                            <tr>
                                <th class="text-center" width="1">#</th>
                                <th>Horário do envio</th>
                                <th>Coletor</th>
                                <th>Diretório</th>
                                <th>Responsável</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-if="!$ctrl.historicos.length">
                                <td colspan="5" class="text-center text-muted">Nenhum envio de arquivo realizado.</td>
                            </tr>
                            <tr ng-repeat="historico in $ctrl.historicos">
                                <td class="text-center">{{ $index + 1}}</td>
                                <td>
                                    <i>{{ historico.insertedAt | date:'dd/MM/yyyy' }}</i> às
                                    <i>{{ historico.insertedAt | date:'HH:mm' }}</i>
                                </td>
                                <td>{{ historico.coletor.nome }}</td>
                                <td>{{ historico.config.diretorio }}</td>
                                <td>{{ historico.coletor.usuario.nome }}</td>
                            </tr>
                        </tbody>
                    </table>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        `
    })
